import { render, staticRenderFns } from "./AdminSegmentSchema.vue?vue&type=template&id=998a4dae&"
import script from "./AdminSegmentSchema.vue?vue&type=script&lang=js&"
export * from "./AdminSegmentSchema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports